import { styled } from '@mui/material';
import MuiAutocomplete from '@mui/material/Autocomplete';

export const Autocomplete = styled(MuiAutocomplete)(({ theme }) => ({
    '& + .MuiAutocomplete-popper': {
        '& .MuiAutocomplete-listbox': {
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.border.main}`,
            borderRadius: theme.spacing(1),
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
            padding: theme.spacing(1),
        },
        // group by label
        '& .MuiAutocomplete-groupLabel': {
            backgroundColor: theme.palette.background.paper,
            borderBottom: `1px solid ${theme.palette.border.main}`,
            letterSpacing: 1.5,
            fontSize: 12,
            textTransform: 'uppercase',
            fontWeight: 'bold',
            fontStyle: 'italic',
            padding: '4px 8px',
            lineHeight: '16px',
            margin: '8px 0',
        },
        '&  .MuiAutocomplete-option': {
            fontWeight: 700,
            fontSize: 14,
        },
        '&  .MuiAutocomplete-option:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        "&  .MuiAutocomplete-option[aria-selected='true']:hover": {
            backgroundColor: theme.palette.action.hover,
        },
    },
    '& .MuiAutocomplete-inputRoot': {
        padding: 0,
    },
    '& .MuiAutocomplete-input': {
        padding: 0,
    },
    '& .MuiChip-root': {
        marginTop: 0,
        marginBottom: 0,
        height: 24,
        borderRadius: theme.spacing(1),
        padding: 0,
        '& .MuiChip-label': {
            fontSize: 12,
            color: theme.palette.common.white,
        },
        '& .fi': {
            color: theme.palette.common.white,
            fontSize: 12,
        },
    },
}));
